interface IconProps {
    fill?: string;
    color?: string;
    strokeColor?: string;
    isActive?: boolean;
    isCompleted?: boolean
}


export const LicenceDetails = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M2.91663 8.33317C2.91663 5.19047 2.91663 3.61913 3.95396 2.64281C4.99129 1.6665 6.66084 1.6665 9.99996 1.6665H10.6439C13.3616 1.6665 14.7204 1.6665 15.6641 2.33137C15.9344 2.52186 16.1745 2.74777 16.3769 3.00224C17.0833 3.8904 17.0833 5.1693 17.0833 7.72711V9.84832C17.0833 12.3176 17.0833 13.5523 16.6925 14.5384C16.0643 16.1237 14.7357 17.3741 13.0513 17.9654C12.0036 18.3332 10.6918 18.3332 8.06814 18.3332C6.56892 18.3332 5.81931 18.3332 5.22061 18.123C4.25812 17.7851 3.49892 17.0706 3.13993 16.1647C2.91663 15.6012 2.91663 14.8957 2.91663 13.4847V8.33317Z" stroke={finalStrokeColor} stroke-width="1.5" stroke-linejoin="round" />
            <path d="M17.0833 10C17.0833 11.5341 15.8397 12.7778 14.3056 12.7778C13.7507 12.7778 13.0966 12.6806 12.5572 12.8251C12.0779 12.9535 11.7035 13.3279 11.5751 13.8072C11.4306 14.3466 11.5278 15.0007 11.5278 15.5556C11.5278 17.0897 10.2841 18.3333 8.75 18.3333" stroke={finalStrokeColor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M6.66663 5.83301H12.5" stroke={finalStrokeColor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path opacity="0.4" d="M6.66663 9.1665H9.16663" stroke={finalStrokeColor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

    );
};



export const BusinessDetails = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M8.33333 10.2781C8.33333 10.0198 8.33333 9.89062 8.36173 9.78464C8.43878 9.49707 8.66341 9.27244 8.95098 9.19539C9.05696 9.16699 9.18612 9.16699 9.44444 9.16699H10.5556C10.8139 9.16699 10.943 9.16699 11.049 9.19539C11.3366 9.27244 11.5612 9.49707 11.6383 9.78464C11.6667 9.89062 11.6667 10.0198 11.6667 10.2781V10.8337C11.6667 11.7541 10.9205 12.5003 10 12.5003C9.07952 12.5003 8.33333 11.7541 8.33333 10.8337V10.2781Z"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M11.5013 10.8333C11.761 10.7579 12.0555 10.6671 12.4 10.5608L15.876 9.48886C17.1131 9.10734 17.7186 8.44248 17.8504 7.29148C17.9093 6.77665 17.9387 6.51924 17.8973 6.30852C17.7791 5.7072 17.2741 5.21962 16.6011 5.05699C16.3652 5 16.0692 5 15.477 5H4.52297C3.93083 5 3.63477 5 3.39892 5.05699C2.72592 5.21962 2.22092 5.7072 2.10269 6.30852C2.06126 6.51924 2.09072 6.77665 2.14964 7.29148C2.28136 8.44248 2.88687 9.10734 4.12401 9.48886L7.59996 10.5608C7.94446 10.6671 8.23903 10.7579 8.4987 10.8333"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
            />
            <path opacity="0.4" d="M2.88569 9.16699L2.72215 10.9772C2.42901 14.2221 2.28243 15.8446 3.22278 16.8808C4.16313 17.917 5.78209 17.917 9.02001 17.917H10.98C14.2179 17.917 15.8369 17.917 16.7772 16.8808C17.7176 15.8446 17.571 14.2221 17.2778 10.9772L17.1143 9.16699"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.4" d="M12.9167 4.5835L12.8523 4.36274C12.5314 3.2627 12.371 2.71269 11.9891 2.39809C11.6072 2.0835 11.0999 2.0835 10.0853 2.0835H9.91471C8.90012 2.0835 8.39282 2.0835 8.0109 2.39809C7.62898 2.71269 7.46856 3.2627 7.14772 4.36274L7.08333 4.5835"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
            />
        </svg>
    );
};


export const FucaltyDetails = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4045_19553)">
                <path opacity="0.4" d="M13.3333 8.3335L15.1245 8.87084C16.2688 9.21414 16.841 9.38579 17.1705 9.82866C17.5 10.2715 17.5 10.8689 17.5 12.0636V18.3335"
                    stroke={finalStrokeColor}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M6.66667 7.5L9.16667 7.5M6.66667 10.8333L9.16667 10.8333"
                    stroke={finalStrokeColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M10 18.3337V15.8337C10 15.048 10 14.6551 9.75592 14.4111C9.51185 14.167 9.11901 14.167 8.33333 14.167H7.5C6.71433 14.167 6.32149 14.167 6.07741 14.4111C5.83333 14.6551 5.83333 15.048 5.83333 15.8337V18.3337"
                    stroke={finalStrokeColor}
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
                <path d="M1.66667 18.3335L18.3333 18.3335"
                    stroke={finalStrokeColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path d="M2.5 18.3337V5.59803C2.5 3.50573 2.5 2.45959 3.15932 1.94053C3.81864 1.42147 4.78951 1.70328 6.73127 2.2669L10.8979 3.47634C12.0697 3.81646 12.6556 3.98652 12.9945 4.45004C13.3333 4.91355 13.3333 5.54485 13.3333 6.80746V18.3337"
                    stroke={finalStrokeColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4045_19553">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};



export const DocumentUpload = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="16" height="20" viewBox="0 0 16 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M8.41663 1.6665H8.6439C11.3616 1.6665 12.7204 1.6665 13.6641 2.33137C13.9344 2.52186 14.1745 2.74777 14.3769 3.00224C15.0833 3.8904 15.0833 5.1693 15.0833 7.72711V9.84832C15.0833 12.3176 15.0833 13.5523 14.6925 14.5384C14.0643 16.1237 12.7357 17.3741 11.0513 17.9654C10.0036 18.3332 8.69178 18.3332 6.06814 18.3332C4.56892 18.3332 3.81931 18.3332 3.22061 18.123C2.25812 17.7851 1.49892 17.0706 1.13993 16.1647C0.916626 15.6012 0.916626 14.8957 0.916626 13.4847V9.99984"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M15.0833 10C15.0833 11.5341 13.8397 12.7778 12.3056 12.7778C11.7507 12.7778 11.0966 12.6806 10.5572 12.8251C10.0779 12.9535 9.70353 13.3279 9.5751 13.8072C9.43056 14.3466 9.52778 15.0007 9.52778 15.5556C9.52778 17.0897 8.28412 18.3333 6.75 18.3333"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.4" d="M1.75 3.74984C2.15961 3.32842 3.24981 1.6665 3.83333 1.6665M5.91667 3.74984C5.50706 3.32842 4.41686 1.6665 3.83333 1.6665M3.83333 1.6665L3.83333 8.33317"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const Summary = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M12.1242 10.0003C12.1242 11.1509 11.1915 12.0837 10.0409 12.0837C8.89031 12.0837 7.95757 11.1509 7.95757 10.0003C7.95757 8.84973 8.89031 7.91699 10.0409 7.91699C11.1915 7.91699 12.1242 8.84973 12.1242 10.0003Z"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
            />
            <path d="M1.66675 10.0002C1.66675 7.05226 1.66675 5.57831 2.54408 4.59425C2.6844 4.43685 2.83906 4.29129 3.00629 4.15922C4.05186 3.3335 5.61793 3.3335 8.75008 3.3335H11.2501C14.3822 3.3335 15.9483 3.3335 16.9939 4.15922C17.1611 4.29129 17.3158 4.43685 17.4561 4.59425C18.3334 5.57831 18.3334 7.05226 18.3334 10.0002C18.3334 12.9481 18.3334 14.422 17.4561 15.4061C17.3158 15.5635 17.1611 15.709 16.9939 15.8411C15.9483 16.6668 14.3822 16.6668 11.2501 16.6668H8.75008C5.61793 16.6668 4.05186 16.6668 3.00629 15.8411C2.83906 15.709 2.6844 15.5635 2.54408 15.4061C1.66675 14.422 1.66675 12.9481 1.66675 10.0002Z"
                stroke={finalStrokeColor}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.4" d="M15.4249 10H15.4174"
                stroke={finalStrokeColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.4" d="M4.58337 10H4.57589"
                stroke={finalStrokeColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const Configuration = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.27572 17.9164C8.35249 16.0823 10.8186 15.866 12.2231 17.2675C12.5371 17.5809 12.6941 17.7376 12.8333 17.7564C12.9726 17.7751 13.1277 17.687 13.4378 17.5109L14.8751 16.6949C15.1912 16.5154 15.3492 16.4257 15.4043 16.2954C15.4594 16.1652 15.4017 15.9432 15.2864 15.4991C14.8669 13.8844 15.8842 12.1852 17.5095 11.7469C17.9444 11.6296 18.1618 11.5709 18.2477 11.4588C18.3337 11.3467 18.3337 11.1663 18.3337 10.8055V9.1941C18.3337 8.83335 18.3337 8.65294 18.2477 8.54077C18.1618 8.42869 17.9444 8.37002 17.5095 8.25277C15.8839 7.81446 14.8658 6.11519 15.2852 4.50044C15.4004 4.05633 15.4581 3.83427 15.403 3.70406C15.3479 3.57386 15.1899 3.48413 14.8738 3.30466L13.4366 2.48863C13.1263 2.31251 12.9712 2.22445 12.8321 2.2432C12.6928 2.26196 12.5358 2.41863 12.2217 2.73197C11.0057 3.94512 8.99366 3.94517 7.77763 2.73205C7.46353 2.41871 7.30648 2.26204 7.16728 2.24329C7.02808 2.22454 6.87298 2.3126 6.56278 2.48871L5.12553 3.30474C4.80943 3.48422 4.65138 3.57395 4.59629 3.70418C4.54122 3.8344 4.5989 4.05643 4.71426 4.5005C5.13373 6.1152 4.11649 7.81443 2.49118 8.25275C2.05625 8.37002 1.83878 8.42869 1.75289 8.54085C1.66699 8.65294 1.66699 8.83335 1.66699 9.1941V10.8055C1.66699 11.1663 1.66699 11.3467 1.75289 11.4589C1.8388 11.571 2.05616 11.6296 2.49088 11.7468C2.49598 11.7482 2.50107 11.7496 2.50616 11.7509"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round" />
            <path
                opacity="0.4"
                d="M2.07441 15.2356C2.97441 14.3356 6.03442 11.3056 6.33442 10.9556C6.65156 10.5856 6.39442 10.0856 6.54742 8.53561C6.62145 7.78561 6.78278 7.22373 7.24442 6.80561C7.79442 6.28561 8.24438 6.28561 9.79438 6.25062C11.1444 6.28561 11.3044 6.13561 11.4444 6.48562C11.5444 6.73562 11.2444 6.88561 10.8844 7.28562C10.0844 8.08561 9.61438 8.48561 9.56938 8.73561C9.24438 9.83561 10.5244 10.4856 11.2244 9.78561C11.4891 9.52086 12.7144 8.28561 12.8344 8.18561C12.9244 8.10561 13.1399 8.10944 13.2444 8.23561C13.3344 8.32403 13.3444 8.33561 13.3344 8.73561C13.3251 9.10586 13.3293 9.63744 13.3304 10.1856C13.3319 10.8959 13.2944 11.6856 12.9944 12.0856C12.3944 12.9856 11.3944 13.0356 10.4944 13.0756C9.64438 13.1256 8.94438 13.0356 8.72438 13.1956C8.54438 13.2856 7.59442 14.2856 6.44442 15.4356L4.39442 17.4856C2.69442 18.8356 0.824421 16.7356 2.07441 15.2356Z"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round"
            />
        </svg>

    );
};

export const Documents = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M10.417 1.6665H10.6443C13.3619 1.6665 14.7208 1.6665 15.6644 2.33137C15.9348 2.52186 16.1748 2.74777 16.3772 3.00224C17.0837 3.8904 17.0837 5.1693 17.0837 7.72711V9.84832C17.0837 12.3176 17.0837 13.5523 16.6929 14.5384C16.0646 16.1237 14.736 17.3741 13.0517 17.9654C12.004 18.3332 10.6921 18.3332 8.06851 18.3332C6.56928 18.3332 5.81967 18.3332 5.22097 18.123C4.25849 17.7851 3.49928 17.0706 3.1403 16.1647C2.91699 15.6012 2.91699 14.8957 2.91699 13.4847V9.99984" stroke="#F07F1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M17.0833 10C17.0833 11.5341 15.8397 12.7778 14.3056 12.7778C13.7507 12.7778 13.0966 12.6806 12.5572 12.8251C12.0779 12.9535 11.7035 13.3279 11.5751 13.8072C11.4306 14.3466 11.5278 15.0007 11.5278 15.5556C11.5278 17.0897 10.2841 18.3333 8.75 18.3333"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path
                opacity="0.4" d="M3.75 3.74984C4.15961 3.32842 5.24981 1.6665 5.83333 1.6665M7.91667 3.74984C7.50706 3.32842 6.41686 1.6665 5.83333 1.6665M5.83333 1.6665L5.83333 8.33317"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>


    );
};

export const LicenceActivities = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="18" height="20" viewBox="0 0 18 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M9.44118 1.66699C12.7687 1.66699 14.4325 1.66699 15.4663 2.6433C16.5 3.61961 16.5 5.19096 16.5 8.33366V11.667C16.5 14.8097 16.5 16.381 15.4663 17.3573C14.4325 18.3337 12.7687 18.3337 9.44118 18.3337H8.55882C5.23126 18.3337 3.56748 18.3337 2.53374 17.3573C1.5 16.381 1.5 14.8097 1.5 11.667L1.5 8.33366C1.5 5.19096 1.5 3.61961 2.53374 2.6433C3.56748 1.66699 5.23126 1.66699 8.55882 1.66699L9.44118 1.66699Z"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round" />
            <path opacity="0.4" d="M5.6665 5.83398H12.3332"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round" />
            <path opacity="0.4" d="M5.6665 10H12.3332"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round" />
            <path opacity="0.4" d="M5.6665 14.167L8.99984 14.167"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round" />
        </svg>

    );
};

export const ServciesOffered = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="18" viewBox="0 0 20 18" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M16.2189 2.32846C13.9842 0.957691 12.0337 1.51009 10.862 2.39001L9.99991 3.03465L7.14816 5.20922C6.35407 5.81474 6.28206 6.98385 6.99583 7.68225C7.53619 8.21098 8.36823 8.30115 9.00932 7.90047L10.8311 6.76187C11.0728 6.6108 11.3883 6.65684 11.5768 6.87066L16.1811 12.0944C19.4734 7.91981 18.584 3.77924 16.2189 2.32846Z"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round" />
            <path opacity="0.4" d="M16.1809 12.0944C15.3907 13.0964 14.3596 14.1003 13.0502 15.0695C11.7617 16.0232 11.1175 16.5 9.99984 16.5C8.88218 16.5 8.23794 16.0232 6.94945 15.0695C0.184604 10.0624 0.848228 4.12745 3.78104 2.32846C6.01574 0.957691 7.96619 1.51009 9.13788 2.39001L9.99967 3.03465" 
                stroke={finalStrokeColor} 
                stroke-width="1.5" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
        </svg>
        
    );
};

export const EmploymentDetails = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="22" height="20" viewBox="0 0 22 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4" d="M13 7H17" stroke="#F07F1A" stroke-width="1.5" stroke-linecap="round"/>
        <path opacity="0.4" d="M13 10.5H16" 
            stroke={finalStrokeColor}
            stroke-width="1.5"
            stroke-linecap="round" />
        <rect x="1" y="1" width="20" height="18" rx="5"
            stroke={finalStrokeColor}
            stroke-width="1.5"
            stroke-linejoin="round" />
        <path opacity="0.4" d="M4 14C5.20831 11.4189 9.71218 11.2491 11 14" 
            stroke={finalStrokeColor} 
            stroke-width="1.5" 
            stroke-linecap="round" 
            stroke-linejoin="round"/>
        <path opacity="0.4" d="M9.5 7C9.5 8.10457 8.60457 9 7.5 9C6.39543 9 5.5 8.10457 5.5 7C5.5 5.89543 6.39543 5 7.5 5C8.60457 5 9.5 5.89543 9.5 7Z" 
            stroke={finalStrokeColor} 
            stroke-width="1.5"/>
        </svg>
        
    );
};

export const CapitalInvestment = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M15.8337 4.16699C16.1201 4.20882 16.3984 4.26117 16.667 4.3232C17.1597 4.43699 17.406 4.49389 17.7012 4.72941C17.8695 4.86374 18.0796 5.12963 18.1719 5.3251C18.3337 5.66782 18.3337 6.00016 18.3337 6.66484V15.7169C18.3337 16.5445 17.467 17.1129 16.667 16.9281C15.9006 16.7511 15.0553 16.653 14.167 16.653C12.5694 16.653 11.1108 16.9703 10.0003 17.4933C8.88988 18.0163 7.43122 18.3337 5.83366 18.3337C4.94539 18.3337 4.10006 18.2356 3.33366 18.0585C2.84099 17.9447 2.59465 17.8879 2.29948 17.6523C2.13113 17.518 1.92102 17.2521 1.82876 17.0566C1.66699 16.7139 1.66699 16.3816 1.66699 15.7169V6.66484C1.66699 5.83726 2.53368 5.26885 3.33366 5.45362C3.60226 5.51566 3.88055 5.568 4.16699 5.60983"
                    stroke={finalStrokeColor}
                    stroke-width="1.5"
                    stroke-linecap="round" />
            <path d="M12.0837 11.2503C12.0837 12.4009 11.1509 13.3337 10.0003 13.3337C8.84973 13.3337 7.91699 12.4009 7.91699 11.2503C7.91699 10.0997 8.84973 9.16699 10.0003 9.16699C11.1509 9.16699 12.0837 10.0997 12.0837 11.2503Z"
                    stroke={finalStrokeColor}
                    stroke-width="1.5" />
            <path d="M4.58398 12.084L4.58398 12.0915" 
                stroke={finalStrokeColor} 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
            <path d="M15.417 10.4102L15.417 10.4176" 
                stroke={finalStrokeColor} 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"/>
            <path opacity="0.4" d="M10.0003 1.66699V5.00033M6.66699 4.16699L6.66699 5.83366M13.3337 2.50033V4.16699" 
                stroke={finalStrokeColor} 
                stroke-width="1.5" 
                stroke-linecap="round"/>
        </svg>
    );
};

export const Construction = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M18.3337 8.33366V7.68157C18.3337 6.06522 18.3337 5.25705 17.8455 4.75491C17.3573 4.25278 16.5717 4.25278 15.0003 4.25278H13.2681C12.5036 4.25278 12.4974 4.25129 11.8099 3.90728L9.03355 2.51794C7.87436 1.93786 7.29476 1.64782 6.67731 1.66798C6.05985 1.68813 5.4993 2.01539 4.3782 2.66992L3.35497 3.2673C2.53148 3.74807 2.11973 3.98846 1.89336 4.38836C1.66699 4.78827 1.66699 5.27527 1.66699 6.24927V13.0968C1.66699 14.3765 1.66699 15.0164 1.95221 15.3725C2.142 15.6095 2.40796 15.7688 2.70199 15.8216C3.14388 15.901 3.68489 15.5851 4.76689 14.9534C5.50162 14.5245 6.20875 14.079 7.08772 14.1998C7.82424 14.301 8.50866 14.7657 9.16699 15.0952" 
                    stroke={finalStrokeColor} 
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"/>
                <path d="M6.66699 1.66699L6.66699 14.167" 
                    stroke={finalStrokeColor} 
                    stroke-width="1.5" 
                    stroke-linejoin="round"/>
                <path d="M12.5 4.16699V7.91699" 
                    stroke={finalStrokeColor} 
                    stroke-width="1.5" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"/>
                <path opacity="0.4" d="M15.2576 18.0696C15.0769 18.2388 14.8354 18.3333 14.5841 18.3333C14.3327 18.3333 14.0912 18.2388 13.9105 18.0696C12.2559 16.5108 10.0386 14.7695 11.1199 12.2415C11.7046 10.8746 13.1081 10 14.5841 10C16.0601 10 17.4636 10.8746 18.0482 12.2415C19.1282 14.7664 16.9163 16.5162 15.2576 18.0696Z" 
                    stroke={finalStrokeColor} 
                    stroke-width="1.5"/>
                <path opacity="0.4" d="M14.584 13.75H14.5915"
                    stroke={finalStrokeColor} 
                    stroke-width="2" 
                    stroke-linecap="round" 
                    stroke-linejoin="round"/>
        </svg>
    );
};

export const Workforce = ({
    fill = "none",
    strokeColor,
    isActive,
    isCompleted
}: IconProps) => {
    const finalStrokeColor = strokeColor ?? (isActive || isCompleted ? "#F07F1A" : "#9E8F82");

    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M9.17238 17.5007H8.00488C5.01717 17.5007 3.52332 17.5007 2.59515 16.5549C1.66699 15.609 1.66699 14.0868 1.66699 11.0423C1.66699 7.99783 1.66699 6.47559 2.59515 5.52979C3.52332 4.58398 5.01717 4.58398 8.00488 4.58398H11.1738C14.1615 4.58398 15.6554 4.58398 16.5835 5.52979C17.2977 6.25748 17.4623 7.3264 17.5003 9.16732"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round" 
                stroke-linejoin="round"/>
            <path opacity="0.4" d="M15.709 15.709L14.584 14.959V13.084M10.834 14.584C10.834 16.6551 12.5129 18.334 14.584 18.334C16.6551 18.334 18.334 16.6551 18.334 14.584C18.334 12.5129 16.6551 10.834 14.584 10.834C12.5129 10.834 10.834 12.5129 10.834 14.584Z"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"/>
            <path d="M13.334 4.58366L13.2512 4.32611C12.8387 3.04274 12.6324 2.40105 12.1414 2.03402C11.6504 1.66699 10.9981 1.66699 9.69364 1.66699H9.47433C8.16985 1.66699 7.51762 1.66699 7.02658 2.03402C6.53554 2.40105 6.32928 3.04274 5.91677 4.32611L5.83398 4.58366"
                stroke={finalStrokeColor}
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>        
    );
};



